'use strict';

var formValidation = require('app_storefront_base/components/formValidation');
var createErrorNotification = require('app_storefront_base/components/errorNotification');

module.exports = {
    submitOptinForm: function () {
        $('form.optin-form').submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            $form.spinner().start();

            $('.invalid-feedback').empty();
            $('.alert').remove();

            var type = $('input[name=dwfrm_optInCampaign_customer_communicationPreference]:checked').val();
            var url = $form.attr('action');
            url = url + '?type=' + type;
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    if (!data.success) {
                        formValidation($form, data);
                        $form.spinner().stop();
                    } else {
                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($('.error-message'), err.responseJSON.message);
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    }
};
